// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3t71B","left":"styles_left__tQPsD","desktopActions":"styles_desktopActions__1_G6X","title":"styles_title__2WNcN"};